import React from 'react';
import { Link } from 'react-router-dom';

const Impressum = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <Link to="/" className="inline-block mb-6 text-blue-600 hover:text-blue-800">
        ← Zurück zur Startseite
      </Link>
      
      <h1 className="text-3xl font-bold mb-6">Impressum</h1>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Angaben gemäß § 5 TMG:</h2>
        <p className="mb-4">
          Bollwerk-X GmbH<br />
          Helene-Meiser-Weg 29<br />
          44227 Dortmund
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Kontakt:</h2>
        <p className="mb-4">
          Telefon: +49 173 1629639<br />
          E-Mail: grosse@bollwerk-x.de<br />
          Web: www.bollwerk-x.de
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Geschäftsführung:</h2>
        <p className="mb-4">Victor Grosse</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Handelsregister:</h2>
        <p className="mb-4">
          Eingetragen beim Amtsgericht Dortmund<br />
          Registernummer: HRB 37226
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h2>
        <p className="mb-4">
          Victor Grosse<br />
          Adresse wie oben
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Umsatzsteuer-Identifikationsnummer:</h2>
        <p className="mb-4">DE368638715</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Hinweis zur Online-Streitbeilegung gemäß Art. 14 Abs. 1 ODR-VO:</h2>
        <p className="mb-4">
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit, 
          die Sie unter <a href="http://ec.europa.eu/consumers/odr/" className="text-blue-600 hover:text-blue-800 underline" target="_blank" rel="noopener noreferrer">http://ec.europa.eu/consumers/odr/</a> finden.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">Haftungsausschluss für externe Links:</h2>
        <p className="mb-4">
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. 
          Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
          Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten 
          wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum 
          Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist 
          jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von 
          Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>
      </section>
    </div>
  );
};

export default Impressum; 